<template>
  <ul class="Pagination">
    <li>
      <a @click="prev"><i class="fas fa-angle-left"></i></a>
    </li>

    <li v-for="n in pages" :class="{ 'active' : n === page }">
      <a v-if="n !== '...'" @click="set (n)">{{ n }}</a>
      <v-popover
        trigger='click'
        placement='top'
        popoverBaseClass="tooltip"
        style="display: inline-block"
        class="Pagination-jumpbox"
        v-else
      >
        <a>...</a>

        <template slot="popover">
          <input type="text" placeholder="Page No." @change="set ($event.target.value)" class="no-border" />
        </template>
      </v-popover>
    </li>

    <li>
      <a @click="next"><i class="fas fa-angle-right"></i></a>
    </li>
  </ul>
</template>

<script>
  import { range } from '@/legacy/lib//util';

  export default {
    props: {
      perPage: {
        type: Number,
        default: 5
      },

      numRecords: {
        type: Number,
        default: 0
      },

      maxWidth: {
        type: Number,
        default: 9
      },
      // Page
      value: {
        type: Number,
        default: 1
      }
    },

    computed: {
      page: {
        get () {
          return this.value;
        },

        set (val) {
          this.$emit ('input', val)
        }
      },

      pages () {
        let pages = [],
            width = this.maxWidth,
            totalPages = this.totalPages,

            inner, half, lowerBound, upperBound, startIndex;

        if (totalPages <= 0 || this.page > totalPages) {
          return [];
        }

        width = Math.min (totalPages, width);
        half  = Math.floor (width / 2)
        inner = width - 2;

        // console.log (`width: ${width}, half: ${half}, inner: ${inner}`);

        pages = [ ... new Array (width) ];

        pages [0] = 1;
        pages [width - 1] = totalPages;

        if (width !== totalPages && this.page >= inner) {
          pages [1] = '...';
          inner--;
        } else {
          lowerBound = 2;
        }

        if (width !== totalPages && this.page + half < totalPages) {
          pages [width - 2] = '...';
          inner--;
        } else {
          upperBound = totalPages - 1;
        }

        if (lowerBound) {
          upperBound = lowerBound + inner - 1;
        } else if (upperBound) {
          lowerBound = upperBound - inner + 1;
        } else {
          // Dots on both sides
          lowerBound = this.page - Math.floor ((inner - 1) / 2);
          upperBound = this.page + Math.floor (inner / 2);
        }

        // console.log (lowerBound + ' -> ' + upperBound);
        // console.log (pages);

        /** **/

        startIndex = pages.indexOf (undefined);

        if (startIndex === -1) {
          return pages;
        }

        for (let i = 0; i < inner; i++) {
          pages [startIndex + i] = lowerBound + i;
        }

        return pages;
      },

      totalPages () {
        return Math.ceil (this.numRecords / this.perPage);
      }
    },

    methods: {
      next () {
        this.page = Math.min (this.page + 1, this.totalPages);
      },

      prev () {
        this.page = Math.max (1, this.page - 1);
      },

      set (page) {
        this.page = Math.min (Math.max (1, page), this.totalPages);
      }
    }
  };
</script>

<style lang="scss">
  .Pagination {
    display: flex;
    flex-grow: 1;
    list-style-type: none;

    list-style-type: none;
    margin: 0;

    li {
      margin: 0;
      display: inline-block;
    }

    li a {
      @extend %W3S-form__button;

      width: auto;
      padding: 8px 10px;
      margin: 0;
      font-size: 18px;
    }

    li.active a {
      color: $w3s-active-colour;
    }
  }
</style>